<template>
  <div
    v-if="firebaseConfigured"
    id="appleSignIn"
    class="apple-sign-in mx-4 d-flex align-items-center justify-content-center"
    @click="handleAppleSignIn"
  >
    <Icon name="apple-sign-in" width="22" fill="black" />
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, OAuthProvider } from 'firebase/auth';
import { SOCIAL_NETWORK } from '@/constants/auth';
import { FIREBASE_API_KEY, FIREBASE_PROJECT_ID } from '@/api/config';
import Icon from '@/components/atoms/Icon';

const appleProvider = new OAuthProvider('apple.com');

export default {
  name: 'AppleSignIn',
  components: {
    Icon,
  },
  data() {
    return {
      auth: null,
    };
  },
  computed: {
    firebaseConfigured() {
      return Boolean(FIREBASE_API_KEY && FIREBASE_PROJECT_ID);
    },
  },
  mounted() {
    if (this.firebaseConfigured) {
      const firebaseConfig = {
        apiKey: FIREBASE_API_KEY,
        authDomain: `${FIREBASE_PROJECT_ID}.firebaseapp.com`,
        projectId: FIREBASE_PROJECT_ID,
      };
      const app = initializeApp(firebaseConfig, 'APPLE');
      this.auth = getAuth(app);
    }
  },
  methods: {
    ...mapActions(['getCredentials', 'snsAuthRequest']),
    handleAppleSignIn() {
      signInWithPopup(this.auth, appleProvider).then(result => {
        const credential = OAuthProvider.credentialFromResult(result);

        const user = result.user;
        const email = user.email;
        if (!email) {
          return;
        }
        var applePayload = JSON.stringify({
          accessToken: credential.accessToken,
          idToken: credential.idToken,
        });
        this.getCredentials(email)
          .then(() => {
            this.snsAuthRequest({
              networkType: SOCIAL_NETWORK.APPLE,
              payload: applePayload,
            }).then(() => {
              const path = this.$route.query.redirectTo || '/';

              this.$router.push({ path });
            });
          })
          .catch(err => {
            if (err.status === 404) {
              this.$router.push({
                name: 'snsSignup',
                query: { redirectTo: this.$route.query.redirectTo },
                params: {
                  networkType: SOCIAL_NETWORK.APPLE,
                  payload: applePayload,
                },
              });
            }
          });
      });
    },
  },
};
</script>
<style lang="scss">
.apple-sign-in {
  background-color: white;
  border-radius: 20px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}
</style>
